import { render, staticRenderFns } from "./quick-form.vue?vue&type=template&id=1ba01a00"
import script from "./quick-form.vue?vue&type=script&lang=js"
export * from "./quick-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba01a00')) {
      api.createRecord('1ba01a00', component.options)
    } else {
      api.reload('1ba01a00', component.options)
    }
    module.hot.accept("./quick-form.vue?vue&type=template&id=1ba01a00", function () {
      api.rerender('1ba01a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bulk-message/quick-form.vue"
export default component.exports